"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Size = exports.Kind = void 0;
const Kind = {
  PRIMARY: 'primary',
  PRIMARY_REVERSE: 'primary_outline',
  SECONDARY: 'secondary',
  SECONDARY_REVERSE: 'secondary_outline',
  MINIMAL: 'minimal',
  MINIMAL_SECONDARY: 'minimal_secondary',
  TERTIARY: 'tertiary'
};
exports.Kind = Kind;
const Size = {
  SMALL: 'small',
  STANDARD: 'standard',
  LARGE: 'large'
};
exports.Size = Size;